import { motion } from "framer-motion";

const ContentBlock = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 3, ease: "easeIn" }}
  >
    {children}
  </motion.div>
);
export default ContentBlock;
